import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { IconPlusInBox } from 'assets/svg/sprite'
import { addToast } from 'components/Toast/Toast'
import CreditCard from 'components/UI/Modal/CreditCard/CreditCard'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { Cards, Funds } from 'components-ref/molecules/wallet'
import { useModalContext } from 'context/modalContext'
import { usePageTitle } from 'context/pageTitleContext'
import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { postCard } from 'services/endpoints/payment'
import { useAuthStore } from 'store'
import { type AddCardInfoRequestDto, type Card, type PrefillData } from 'types/api/payment'

export const initialPrefillData: PrefillData = {
  id: '',
  name: '',
  cardNumber: '',
  expiration: '',
  cvc: '',
  country: '',
  address: '',
  zip: '',
  state: '',
  city: ''
}

export const Wallet = () => {
  const [prefillData, setPrefillData] = useState<PrefillData>(initialPrefillData)
  const modalData = useModalContext()
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  // const userData = useUserProfile()
  const { setTitle } = usePageTitle()



const addCard = useMutation(
  async (dto: AddCardInfoRequestDto) => {
    console.log('[Wallet:addCard] submitting DTO', dto)

    const response = await postCard(dto)

    console.log('[Wallet:addCard] raw response', response)

    return response
  },
  {
    onSuccess: response => {
      console.log('[Wallet:addCard] onSuccess response', response)

      setPrefillData(initialPrefillData)

      const newCard: Card | undefined = response?.data

      console.log('[Wallet:addCard] parsed new card', newCard)

      if (!newCard?.id) {
        console.error(
          '[Wallet:addCard] could not find new card in response',
          response
        )
        return
      }

      const {
        userProfile,
        setUserProfile
      } = useAuthStore.getState()

  const currentCards: Card[] =
    userProfile?.cards ?? []

      const nextCards = currentCards
        .filter(card => card.id !== newCard.id)
        .map(card => ({
          ...card,
          is_default: newCard.is_default
            ? false
            : card.is_default
        }))

      nextCards.push(newCard)

      console.log(
        '[Wallet:addCard] cards being written',
        nextCards
      )

      setUserProfile({
        cards: nextCards,
        ...(newCard.is_default
          ? { default_card: newCard.id }
          : {})
      })

      console.log(
        '[Wallet:addCard] cards AFTER update',
        useAuthStore.getState().userProfile?.cards
      )

      console.log(
        '[Wallet:addCard] default_card AFTER update',
        useAuthStore.getState().userProfile?.default_card
      )
    },

    onSettled: () => {
      queryClient.invalidateQueries('allCards')
      queryClient.invalidateQueries('user-profile')
    },

    onError: (resp: any) => {
      console.error('[Wallet:addCard] mutation failed', resp)

      addToast(
        'error',
        resp?.response?.data?.error?.message
      )
    }
  }
)

  // modal now passes the FINAL dto (already includes country_id + region_id)
const addCreditCard = async (dto: AddCardInfoRequestDto) => {
  return await addCard.mutateAsync(dto)
}

    useEffect(() => {
        setTitle('Wallet')
    }, [setTitle])

  return (
    <div className='wallet-main'>
      <Funds />
      <WithHeaderSection
        customClass='wallet-main-whs'
        withoutBorder={true}
        headerSection={<LayoutHeader type='basic' title={t('yourCards')} />}
      >
        <Cards setPrefillData={setPrefillData} />

        <ActionCard
          icon={<IconPlusInBox width='22' height='22' />}
          text={t('addAnotherCard')}
          addNewText
          iconSize='big'
          clickFn={() => {
            modalData.addModal(
              'Add Card',
              <CreditCard
                // changed: now expects AddCardInfoRequestDto
                addNewFn={addCreditCard}
                prefillData={prefillData}
              />
            )

            setPrefillData(initialPrefillData)
          }}
        />
      </WithHeaderSection>
    </div>
  )
}
